import { createFileRoute } from '@tanstack/react-router';

import { approvalsHubScreen, approvalsSearch, loadApprovalsHubScreen, loadApprovalsMessages } from '@/modules/approvals/route';
import { lazyScreen } from '@/shared/screen';

// `/aprovacoes`, o `legacyPath` do menu: o hub do legado (`/aprovacoes/gestao-aprovacoes`, router.tsx:694-743)
// mora aqui, com as abas por `?tab=` (como `/concilicao`, S28/S29). Os caminhos antigos redirecionam.
export const Route = createFileRoute('/_app/aprovacoes/')({
  validateSearch: approvalsSearch,
  staticData: { screen: approvalsHubScreen },
  loader: () => loadApprovalsMessages(),
  component: lazyScreen(loadApprovalsHubScreen, 'ApprovalsHubScreen'),
});
